import { matchers } from "../validate-props";
/**
 * Helper function designed to merge objects used by render-state
 * It will combine attrs and classList from the arguments list into a new object
 * @param {{attrs:Object,classList:Array}} args list of states
 * @return {{attrs:Object,classList:Array}}
 */
export default (...args) => {
    if (!args || !Array.from(args)) return { attrs: {}, classList: [] };
    const styles = (Array.from(args) || []).filter(matchers.object);
    return styles.reduce(
        (result, style) => {
            if (matchers.object(style.attrs)) {
                result.attrs = Object.assign(result.attrs, style.attrs);
            }
            if (matchers.array(style.classList)) {
                result.classList = result.classList.concat(style.classList);
            }
            return result;
        },
        { attrs: {}, classList: [] }
    );
};
